import styled from 'styled-components/macro';
import {spacing} from '@mui/system';
import {
  Typography as MuiTypography,
  Divider as MuiDivider,
  DialogTitle,
  DialogActions,
} from '@mui/material';

const StyledIconClose = styled.div`
  position: absolute;
  right: 20px;
  top: 14px;
  cursor: pointer;
`;

const Typography = styled(MuiTypography)(spacing);

const StyledModalTitle = styled(DialogTitle)`
  font-size: 20px;
  font-weight: 900;
`;
const Divider = styled(MuiDivider)`
  ${spacing};
  margin: 10px 0px 12px 0px;
`;
const StyledModalActions = styled(DialogActions)`
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
  gap: 8px;
  .btn-action-1 {
    display: block;
    width: 113px;
    button {
      width: inherit;
    }
  }
  .btn-action-2 {
    display: block;
    width: 113px;
    button {
      width: inherit;
    }
  }
`;

export {
  StyledIconClose,
  Typography,
  StyledModalTitle,
  StyledModalActions,
  Divider,
};
